import { Box, Typography } from "@mui/material";
import DateFilter from "./datefilter";
import { HeaderProps } from "../api/types";



export const Header = ({ onDateChange, walkthroughMenuOpen }: HeaderProps & { walkthroughMenuOpen?: boolean }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        mb: 1,
      }}
    >
      <Box id="dashboard-header" sx={{ textAlign: "left" }}>
        <Typography variant="h4" color="primary.main">
          Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="start">
          Helps admins monitor performance, track activities, and make
          data-driven decisions at a glance.
        </Typography>
      </Box>

      <Box>
        <DateFilter onChange={onDateChange} walkthroughMenuOpen={walkthroughMenuOpen} />
      </Box>
    </Box>
  );
};
